export { default as blogTagContentQuery } from './BlogTagContentQuery';